export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q04_a.40357aae.png";